module.exports = __webpack_public_path__ + "static/w-jaozah-679793f66ae2011cbe09772699a11282.jpg";